import React from 'react';

import Authorization from "../../app/components/Authorization";
import Link from "../../app/components/Link";
import {ButtonAdd} from "../../app/components/ButtonCollection";

import * as RESOURCES from "../../app/constants/resources";
import * as CONST from "../../app/constants/variables";

const ProductionCompanyIndexButtons = () => {
    const authorizationObject = {
        [RESOURCES.PRODUCTION_COMPANY]: CONST.SECURITY_PRIVILEGES_CREATE_READ
    };

    return (
        <div className="content__buttons">
            <Authorization authorization={authorizationObject}>
                <Link name={"productionCompanies.add"}>
                    <ButtonAdd>{'Add new production company'}</ButtonAdd>
                </Link>
            </Authorization>
        </div>
    );
};

export default ProductionCompanyIndexButtons;
